import React from "react";
import { withStyles } from '@material-ui/styles';
import withShowToast from '../../hocs/with_show_toast.js';
import { compose } from 'redux';

import {
  Dialog, DialogActions, 
  DialogContent, 
  DialogTitle
} from '@material-ui/core';

import I18n from "../../base/i18n.js";

import Button from "../../base/buttons/button.js";
import FormFields from "../../base/form/form_fields.js";

import { ProjectCreateInvestmentModel } from "../../models/projects/project_create_investment.js.jsx";

import SaveInvestmentUseCase from "../../use_cases/admin/projects/investments/save_investment_use_case.js";

const styles = theme => ({
  root: {
    "& .MuiDialog-paper": {
      width: "100%",
      maxWidth: "500px"
    }
  }
});

class CreateInvestment extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};

    const investment = {}
    const { user } = props;

    this.investment = {
      ...investment
    }

    this.investment.user_id = user.id;

    this.bodyRef = React.createRef();
  }

  static getDerivedStateFromProps(props, state) {
    return {
      ...state,
      open: props.open
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.state.open !== nextState.open ||
           this.state.submit !== nextState.submit;
  }

  onItemChange = changedItem => {
    this.investment = changedItem
  }

  onSubmit = event => {
    event.preventDefault();
    this.setState({
      submit: true,
      errorData: undefined
    })

    SaveInvestmentUseCase.execute(undefined, this.investment)
    .then((result) => {
      const { data : { investment } } = result;
      const { onSave, close, showSuccessMessage } = this.props;
      if(onSave) {
        onSave(investment);
      }
      showSuccessMessage(I18n.t("shared.toast.successfully_saved"));
      close();
    })
    .catch((result) => {
      const { errorData } = result;
      const { showServerErrorIfNeed } = this.props;
      this.setState({
        submit: false,
        errorData: errorData
      });
      showServerErrorIfNeed(result);
    })
  }

  onClose = (event) => {
    const { onClose } = this.props;
    const { submit } = this.state;
    if(!submit) {
      onClose()
    }
  }
  
  render() {
    const { classes } = this.props;

    const { open, errorData, submit } = this.state;

    let formFields = ProjectCreateInvestmentModel.formFields();

    return <Dialog open = { open } 
                   onClose = { this.onClose }
                   scroll = { "paper" }
                   className = { classes.root } >
    <DialogTitle>
      { I18n.t("admin.modal.create_investment.title") }
    </DialogTitle>
    <form onSubmit = { this.onSubmit } >
      <DialogContent dividers = { true } >
        <FormFields formFields = { formFields } 
                    item = { this.investment }
                    errorData = { errorData }
                    onItemChange = { this.onItemChange } />
      </DialogContent>
      <DialogActions>
        <Button type = { "submit" } 
                disabled = { submit }>
          { I18n.t("action.save") }
        </Button>
      </DialogActions>
    </form>
  </Dialog>
  }
}

export default compose(
  withShowToast,
  withStyles(styles)
)(CreateInvestment);
